<template>
  <div class="button-group-wrapper">
    <div class="button-group">
      <a-button type="primary" @click="handleClick" :disabled="disabled">{{ $t('打开编辑') }}</a-button>
      <a-button type="default" @click="handleCancel" :disabled="!disabled">{{ $t('取消编辑') }}</a-button>
      <a-button type="primary" @click="handleSave" :disabled="!disabled">{{ $t('保存') }}</a-button>
    </div>
    <a-card :title="$t('选择类型')">
      <a-radio-group v-model="model.type" @change="onChange1" :disabled="!disabled">
        <a-radio value="1">{{ $t('节点') }}</a-radio>
        <a-radio value="2">{{ $t('管线') }}</a-radio>
        <a-radio value="3">{{ $t('区域') }}</a-radio>
      </a-radio-group>
    </a-card>
    <a-divider />
    <a-card :title="$t('操作类型')">
      <a-radio-group v-model="model.handleType" @change="onChange2" :disabled="!disabled">
        <a-radio value="1">{{ $t('新增') }}</a-radio>
        <a-radio value="2">{{ $t('编辑') }}</a-radio>
        <a-radio value="3">{{ $t('删除') }}</a-radio>
      </a-radio-group>
    </a-card>
    <a-divider />
    <a-card :title="$t('录入方式')">
      <a-radio-group v-model="model.inputMethod" @change="onChange5" :disabled="!disabled">
        <a-radio value="1">{{ $t('地图绘制') }}</a-radio>
        <a-radio value="2">{{ $t('坐标录入') }}</a-radio>
      </a-radio-group>
      <div style="margin-top: 12px" v-if="model.inputMethod == 2&&(model.type == 1||model.type == 2)">
        <div v-if="model.type == 1">
          {{ $t('坐标') }}
          <a-input-group compact>
            <a-input style="width: 50%" :placeholder="$t('X坐标')" v-model="model.longitude" />
            <a-input style="width: 50%" :placeholder="$t('Y坐标')" v-model="model.latitude" />
          </a-input-group>
        </div>
        <div v-else-if="model.type == 2">
          {{ $t('起点坐标') }}
          <a-input-group compact>
            <a-input style="width: 50%" :placeholder="$t('X坐标')" v-model="model.longitude" />
            <a-input style="width: 50%" :placeholder="$t('Y坐标')" v-model="model.latitude" />
          </a-input-group>
          {{ $t('终点坐标') }}
          <a-input-group compact>
            <a-input style="width: 50%" :placeholder="$t('X坐标')" v-model="model.longitude" />
            <a-input style="width: 50%" :placeholder="$t('Y坐标')" v-model="model.latitude" />
          </a-input-group>
        </div>
        <div class="input-group-botton">
          <a-button type="primary" @click="handleView">{{ $t('预览') }}</a-button>
          <a-button type="primary" @click="handleCoorSave">{{ $t('保存') }}</a-button>
        </div>
      </div>
    </a-card>
    <a-divider />
    <a-card :title="$t('捕捉设置')">
      <div>
        {{ $t('捕捉开关') }}
        <a-switch v-model="model.isCapture" @change="onChange3" :disabled="!disabled" />
      </div>
      <div style="margin-top: 12px" v-if="model.isCapture">
        {{ $t('捕捉容差') }}
        <a-input-number v-model="model.captureTolerance" @change="onChange4" :disabled="!disabled" />
      </div>
    </a-card>
  </div>
</template>
  
  <script>
export default {
  name: 'App',
  components: {},
  data() {
    return {
      type: '1',
      model: {
        type: '1',
        handleType: '1',
        isCapture: false,
        captureTolerance: 20,
        inputMethod: '1',
      },
      disabled: false,
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleClick() {
      this.disabled = true
      this.$emit('changeMap',this.model);
    },
    handleCancel() {
      this.disabled = false
      this.model = {
        type: '1',
        handleType: '1',
        isCapture: false,
        captureTolerance: 20,
        inputMethod: '1',
      }
      this.$emit('cancelDrawMap');
    },
    handleSave(){
      this.$emit('changeSave');
    },
    handleCoorSave(){},
    handleView(){},
    // 选择类型
    onChange1(e) {
      if(this.model.inputMethod == 2){
        this.$emit('cancelDrawMap');
      }else{
        if(this.model.handleType==1){
          this.$emit('changeType', this.model)
        }
      }
    },
    // 操作类型
    onChange2(e) {
      if(this.model.inputMethod == 2){
        this.$emit('cancelDrawMap');
      }else{
        this.$emit('changeHandleType', this.model);
      }
    },
    // 捕捉设置
    onChange3(e) {
      if(this.model.inputMethod == 2){
        this.$emit('cancelDrawMap');
      }else{
        this.$emit('changeCapture', this.model)
      }
    },
    // 捕捉容差
    onChange4(e) {
      if(this.model.inputMethod == 2){
        this.$emit('cancelDrawMap');
      }else{
        this.$emit('changeCaptureTolerance', this.model)
      }
    },
    // 录入方式
    onChange5(e){
      if(this.model.inputMethod == 2){
        this.$emit('cancelDrawMap');
      }else{
        this.$emit('changeMap',this.model);
      }
    }
  },
}
</script>
  
<style lang="less" scoped>
.button-group-wrapper {
  height: 80vh;
  overflow: auto;
  position: relative;
}
.button-group {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #fff;
  .ant-btn {
    width: 31%;
  }
}
.input-group-botton {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .ant-btn {
    width: 48%;
  }
}
</style>
  